import Vue from 'vue';

let alertCounter = 0;

export default new Vue({
  data: () => ({
    user: null,
    token: null,
    alerts: [],
    isLoggingIn: false
  }),
  computed: {
    isLoggedIn () {
      return this.user && this.token;
    }
  },
  methods: {
    setUser (user) {
      this.user = user;
    },
    setToken (token) {
      this.token = token;
    },
    removeAlert (alert) {
      const idx = this.alerts.indexOf(alert);
      if (idx === -1) return;

      this.alerts.splice(idx, 1);
    },
    notify (message, type) {
      this.alerts.push({ id: alertCounter, message, type });
      alertCounter++;
    }
  }
});
